import NotificationActions from '../../actions/NotificationActions';
import RoutingActions from '../../actions/RoutingActions';
import PopupActions from '../../actions/PopupActions';
import GuestActions from '../../actions/GuestActions';

import UserStore from '../../stores/UserStore';
import ConfigStore from '../../stores/ConfigStore';

import AjaxPromises from '../../utils/AjaxPromises';
import { endPoints as GuestEndPoints } from '../../constants/GuestConstants';

class EditImage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading : true,

            img : this.props.data,
            deg : 0,

            id  : this.props.guest.identifications.filter(x => {
                return x.type === 'MJStateIDNo';
            })
        };

        this.rotate = this.rotate.bind(this);
        this.save = this.save.bind(this);
    }

    rotate(isClockwise) {
        var self = this;

        var offScreenCanvas = document.createElement('canvas');
        var offScreenCanvasCtx = offScreenCanvas.getContext('2d');

        var img = new Image();

        img.onload = function() {
            offScreenCanvas.height = img.width;
            offScreenCanvas.width = img.height;

            if (isClockwise) {
                offScreenCanvasCtx.rotate(90 * Math.PI / 180);
                offScreenCanvasCtx.translate(0, -offScreenCanvas.width);
            } else {
                offScreenCanvasCtx.rotate(-90 * Math.PI / 180);
                offScreenCanvasCtx.translate(-offScreenCanvas.height, 0);
            }

            offScreenCanvasCtx.drawImage(img, 0, 0);

            var deg = isClockwise ? self.state.deg + 90 : self.state.deg - 90;

            if (deg > 270)
                deg = 0;

            if (deg < 0)
                deg = 270;

            self.setState({
                img : offScreenCanvas.toDataURL("image/jpeg", 100).split(',')[1],
                deg : deg
            });
        }

        img.src = 'data:image/jpeg;base64, '+this.state.img;
    }

    save() {
        var self = this;

        var guest = this.props.guest;

        this.setState({ loading : true, deg : 0 }, () => {
            AjaxPromises.POST(GuestEndPoints.UPDATE_PRIMARY_ID, UserStore.getApiData({
                Guest_id       : guest.Guest_id,
                MJStateIDNo    : self.state.id.number,
                ExpirationDate : self.state.id.ExpirationDate,
                ImgItem        : self.state.img,
            })).then(res => {
                if (res.Result === 'false') {
                    NotificationActions.error('Image not updated');
                } else {
                    NotificationActions.success('Image updated');
                    GuestActions.loadFullGuest(guest.Guest_id);
                }
            })
        });
    }

    render() {
        var self = this;
        var guest = this.props.guest;

        return (
            <div className='popup edit-image'>
                <div
                    className='popup__content edit-image__block'
                    style={{'width' : '400px', 'height' : '400px', 'overflow':'visible'}}
                    onClick={this.rot}>

                    <img
                        src={'data:image/png;base64, '+this.state.img} />

                    <div className='edit-image__controls'>
                        <i
                            className='fa fa-chevron-left edit-image__controls--left'
                            onClick={() => { this.rotate(false) }} />

                        <i
                            className='fa fa-chevron-right edit-image__controls--right'
                            onClick={() => { this.rotate(true) }} />

                        { this.state.deg !== 0 &&
                            <div
                                className='edit-image__controls--save'
                                onClick={this.save}>

                                SAVE
                            </div>
                        }
                    </div>

                    <div
                        className='edit-image__close'
                        onClick={() => { this.props.onClose(); }}>

                        <i className='fa fa-times' aria-hidden='true' />
                    </div>
                </div>
            </div>
        );
    }
}

export default EditImage;


// WEBPACK FOOTER //
// ./ui_src/app/components/popup/EditImage.react.jsx